<template>
  <b-container>
    <error-indicator v-if="isError" />

    <div v-else>
      <loading-indicator v-if="isLoading" />

      <b-card v-else bg-variant="light" class="mt-1">
        <b-card-title>SafeHarbour Coordinator</b-card-title>
        <b-card-sub-title class="mb-2">for {{appName}} app</b-card-sub-title>

        <b-card-text>
          The Safeharbour Coordinator information appears in various places throughout the app. With the exception of the resources page,
          whatever information you provide below will automatically show up where it needs to. The name and phone number will appear exactly as they do below.
        </b-card-text>
        <validation-observer ref="observer" v-slot="{ handleSubmit }">
          <b-form @submit.stop.prevent="handleSubmit(update)">
            <validation-provider
              name="Coordinator Name"
              :rules="{ required: true, min: 3 }"
              v-slot="validationContext"
            >
              <b-form-group
                id="input-group-name"
                label="Safeharbour Coordinator"
                label-for="category-name-input"
              >
                <b-form-input
                  type="text"
                  class="form-control"
                  id="category-name-input"
                  name="category-name-input"
                  placeholder="Enter name to be displayed"
                  v-model="curCoordinator.name"
                  :state="getValidationState(validationContext)"
                  aria-describedby="input-1-live-feedback"
                ></b-form-input>

                <b-form-invalid-feedback
                  id="input-1-live-feedback"
                >{{ validationContext.errors[0] }}</b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
            <validation-provider name="Coordinator Phone Number" rules="required" v-slot="{errors}">
              <b-form-group
                id="input-group-phone"
                label="Coordinator Phone Number"
                label-for="category-phone-input"
              >
                <VuePhoneNumberInput
                  id="category-phone-input"
                  valid-color="#28a745"
                  v-model="curCoordinator.phone_number"
                  disable-leading-trailing-space
                  :error="errors.length > 0 ? true : false"
                  aria-describedby="input-2-live-feedback"
                  @update="updatePhoneNumber"
                />

                <b-form-invalid-feedback
                  :force-show="true"
                  id="input-2-live-feedback"
                >{{ errors[0] }}</b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
            <b-button type="submit" block pill variant="success">Update Coordinator Information</b-button>
          </b-form>
        </validation-observer>
      </b-card>
    </div>
  </b-container>
</template>

<script>
import { mapGetters } from "vuex";
import LoadingIndicator from "./indicators/LoadingIndicator.vue";
import ErrorIndicator from "./indicators/ErrorIndicator.vue";
import VuePhoneNumberInput from "vue-phone-number-input";

export default {
  components: {
    LoadingIndicator,
    ErrorIndicator,
    VuePhoneNumberInput,
  },

  name: "coordinator-card",

  data: function () {
    return {
      isLoading: true,
      isError: false,
      phonePayload: {},
      curCoordinator: {
        id: 1,
        name: "MaryBeth Ross2",
        phone_number: "8458081500",
        owning_group: 2,
      },
    };
  },

  computed: {
    ...mapGetters(["appId", "curGroup", "appName"]),
  },

  created: function () {
    this.listCoordinator();
  },

  methods: {
    updatePhoneNumber(payload) {
      this.phonePayload = payload;
    },

    listCoordinator: function () {
      if (this.appId == -1) {
        this.$router.push("/ChooseApp");
        return;
      }

      this.isLoading = true;
      this.$http
        .get(
          `${this.$API_URL}safeharbour_coordinator/?owning_group=${this.curGroup}`
        )
        .then((response) => {
          this.curCoordinator = response.data[0];
        })
        .catch((error) => {
          console.log(error);
          //console.log(error.response.data); // returns 404   if no permission
          //this.$router.push("/404");
          this.isError = true;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    getValidationState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },

    handleOk(bvModalEvt) {
      bvModalEvt.preventDefault();
      // Trigger submit handler
      this.update();
    },

    handleSubmit() {
      this.update();
    },

    async update() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid || !this.phonePayload.isValid) {
        this.$bvToast.toast(
          `Validation error. Fix the error before submission`,
          {
            title: "Error detected",
            variant: "warning",
            autoHideDelay: 5000,
          }
        );
        return;
      }

      this.$http
        .put(
          `${this.$API_URL}safeharbour_coordinator/${this.curCoordinator.id}/`,
          {
            name: this.curCoordinator.name,
            phone_number: this.phonePayload.formattedNumber,
            owning_group: this.curGroup,
          }
        )
        .then(() => {
          this.$bvToast.toast(`Safeharbour Coordinator updated successfully!`, {
            title: "Successful Update",
            variant: "success",
            autoHideDelay: 5000,
          });
        })
        .catch((response) => {
          this.$bvToast.toast(
            `An ${response} has occured. An email has been sent to detailing the problem, but please try again!`,
            {
              title: "Error during submission",
              variant: "danger",
              autoHideDelay: 5000,
            }
          );
        });
    },
  },
};
</script>

<style scoped>
.collapsed > .when-open,
.not-collapsed > .when-closed {
  display: none;
}

.bg-custom-3 {
  background-color: #13547a;
}

.centered {
  justify-content: center;
  display: flex;
}
</style>